import React from "react";
import './Home.css';

const Home = () => {
  return (
    <div className='container my-5 about'>
      <span>BGMeetups will be an application where you can play boardgames virtually without needing multiple copies of a game or any other hassle. This app is a work in progress and contains many bugs.</span>
    
      <br/>
      <br/>

      <div>
         <a href="https://github.com/Raf-Batista/BGMeetups">You can view the github repo here</a>
      </div>
    </div>
    
  );
};

export default Home;
